/**
 * AEB设备配置-批量设置表单
 */
import React, { useImperativeHandle, forwardRef } from 'react';
import { Form, InputNumber, Row, Col } from 'antd';
import { formSearchGutter } from '@/constants/common';
import { filterFormValues } from '@/utils/useFormToJsonString';

export interface AebDeviceConfigWriteFormRef {
  getSubmitString: () => Promise<string | null>;
}

const AebDeviceConfigWriteForm = forwardRef<AebDeviceConfigWriteFormRef, {}>((props, ref) => {
  const [form] = Form.useForm();

  // 导出方法：获取表单数据的JSON字符串
  useImperativeHandle(ref, () => ({
    getSubmitString: async () => {
      const values = await form.validateFields();
      return filterFormValues(values);
    }
  }));

  return (
    <Form form={form}>
      <Row gutter={formSearchGutter}>
        <Col span={12}>
          <Form.Item
            label="AEB开关"
            name="aebSwitch"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            extra="0：自启模式 1：常开模式 2：常关模式 3：记忆模式"
          >
            <InputNumber
              min={0}
              max={3}
              precision={0}
              style={{ width: '100%' }}
              placeholder="请输入AEB开关状态"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="设备音量"
            name="volume"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            <InputNumber
              min={0}
              precision={0}
              style={{ width: '100%' }}
              placeholder="请输入设备音量"
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
});

export default AebDeviceConfigWriteForm;
